



















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptCommodityJournal extends Vue {

  // 商品元帳用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public dateFrom: Date = null;
  public dateTo: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public warehouse: Common.Counterpart = null;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public onExcelExport :boolean = false;
  public dateFromFlag : Common.dateFlags = Common.dateFlags.default;
  public dateToFlag : Common.dateFlags = Common.dateFlags.default;  

  public mounted(){
    if ((this.$parent as any).favoriteLoaded == false){    
      var query: Common.CommodityJournalReportTemplateQuery = new Common.CommodityJournalReportTemplateQuery();
      this.$api.execute(query).then(obj => {
        var items: Common.ReportTemplate[] = new Array();
        items = (obj as Common.LoadResult).result;
        if (items.length > 0) this.reportTemplate = items[0];
      });
    }
    var today = new Date();
    this.dateFrom = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.dateTo = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();
    (this.$refs.CommodityJournalDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.CommodityJournalReportQuery = new Common.CommodityJournalReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.dateFrom = this.dateFrom;
    query.dateTo = this.dateTo;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.warehouse = this.warehouse;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.onExcelExport = this.onExcelExport;
    this.$api.download(query);
  }
}
